module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showModal === 'cancelOrder',
      "lazy": true
    },
    on: {
      "hidden": _vm.hideCancelModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.order) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Отменить заказ № " + _vm._s(_vm.order.id))]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Заказ отменяется..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.$v.text.$error
    }
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "cancel-input"
    }
  }, [_vm._v("Причина отмены заказа")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "focusThis",
    staticClass: "form-control",
    attrs: {
      "id": "cancel-input",
      "rows": "4",
      "placeholder": "Укажите по какой причине заказ отменяется?"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }, function($event) {
        _vm.$v.text.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.text.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Для отмены заказа необходимо обязательно указать причину")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('b-btn', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideCancelModal($event)
      }
    }
  }, [_vm._v("Не отменять")]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('b-btn', {
    class: {
      'disabled': _vm.$v.text.$invalid
    },
    attrs: {
      "variant": "danger",
      "disabled": _vm.$v.text.$invalid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Отменить заказ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4092e5a1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-4092e5a1"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalCancelOrder.vue
// module id = 1032
// module chunks = 1